import { usePageMeta } from "@/lib/meta";
import { HtmlBlock } from "@/components/HtmlBlock";
import FieldIndex from "@/components/FieldIndex";
import mainHtml from "@/gen/field_main";
import footerHtml from "@/gen/field_footer";

const rootStyle = { background: "#EEF1F4", color: "#0C0E12", fontFamily: "'IBM Plex Sans',system-ui,sans-serif", lineHeight: 1.6 };

export default function FieldPage() {
  usePageMeta("The Field");
  return (
    <div data-testid="field-page">
      <HtmlBlock html={mainHtml} testId="field-main" />
      <div style={rootStyle}>
        <FieldIndex />
      </div>
      <HtmlBlock html={footerHtml} testId="field-footer" />
    </div>
  );
}
